export default [
  {
    path: '',
    name: 'competitions',
    component: () => import(/* webpackChunkName: "competition" */ '@/views/competitions/competitions.vue')
  },
  {
    path: '/competition/:competitionId/:competitionSlug',
    name: 'competition',
    props: route => ({
      competitionId: parseInt(route.params.competitionId, 10)
    }),
    component: () => import(/* webpackChunkName: "competition" */ '@/views/competition/competition.vue')
  },
  {
    path: '/preview/:competitionId/:updatedAt',
    name: 'preview',
    props: route => ({
      competitionId: parseInt(route.params.competitionId, 10),
      updatedAt: route.params.updatedAt
    }),
    component: () => import(/* webpackChunkName: "competition" */ '@/views/competition/competition.vue')
  }
]
